import React, { useState } from 'react';
import { TrendingUp, TrendingDown, Star } from 'lucide-react';
import Card from '../common/Card';
import Table from '../common/Table';
import { useApi } from '../../hooks/useApi';
import { getPopularItems } from '../../api/client';

const TIME_PERIODS = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
];

const columns = [
  {
    key: 'rank',
    label: '#',
    sortable: false,
    render: (_, __, idx) => (
      <span className="text-text-muted font-mono text-xs">{idx + 1}</span>
    ),
  },
  {
    key: 'classname',
    label: 'Item',
    render: (val, row) => (
      <span className="text-text-primary font-medium text-xs">
        {row?.display_name || row?.item_classname || val || '—'}
      </span>
    ),
  },
  {
    key: 'totalTransactions',
    label: 'Transactions',
    mono: true,
    align: 'right',
    render: (val) => (
      <span className="text-text-primary font-mono text-xs">
        {(val || 0).toLocaleString()}
      </span>
    ),
  },
  {
    key: 'totalVolume',
    label: 'Volume',
    mono: true,
    align: 'right',
    render: (val) => (
      <span className="text-accent-green font-mono text-xs">
        ₽{(val || 0).toLocaleString()}
      </span>
    ),
  },
  {
    key: 'avgPrice',
    label: 'Avg Price',
    mono: true,
    align: 'right',
    render: (val) => (
      <span className="text-text-secondary font-mono text-xs">
        ₽{(val || 0).toLocaleString()}
      </span>
    ),
  },
];

export default function PopularItems() {
  const [tab, setTab] = useState('most');
  const [period, setPeriod] = useState('today');

  const { data, loading } = useApi(
    getPopularItems,
    { period, sort: tab === 'most' ? 'desc' : 'asc', limit: 10 }
  );

  const items = Array.isArray(data) ? data : data?.items || [];

  return (
    <Card title="Popular Items" icon={Star} className="h-full">
      {/* Controls */}
      <div className="flex items-center justify-between mb-3">
        {/* Tabs */}
        <div className="flex gap-1 bg-terminal-bg rounded p-0.5">
          <button
            onClick={() => setTab('most')}
            className={`flex items-center gap-1 px-3 py-1.5 rounded text-[11px] font-mono transition-colors ${
              tab === 'most'
                ? 'bg-accent-green/10 text-accent-green'
                : 'text-text-muted hover:text-text-secondary'
            }`}
          >
            <TrendingUp className="w-3 h-3" />
            Most Traded
          </button>
          <button
            onClick={() => setTab('least')}
            className={`flex items-center gap-1 px-3 py-1.5 rounded text-[11px] font-mono transition-colors ${
              tab === 'least'
                ? 'bg-accent-red/10 text-accent-red'
                : 'text-text-muted hover:text-text-secondary'
            }`}
          >
            <TrendingDown className="w-3 h-3" />
            Least Traded
          </button>
        </div>

        {/* Period selector */}
        <div className="flex gap-1">
          {TIME_PERIODS.map((p) => (
            <button
              key={p.value}
              onClick={() => setPeriod(p.value)}
              className={`px-2 py-1 rounded text-[10px] font-mono transition-colors ${
                period === p.value
                  ? 'bg-accent-blue/10 text-accent-blue border border-accent-blue/20'
                  : 'text-text-muted hover:text-text-secondary'
              }`}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      <Table
        columns={columns}
        data={items}
        loading={loading}
        pageSize={10}
        emptyMessage="No item data available"
      />
    </Card>
  );
}
